// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS
export const FETCH_CUTTING_DC_DETAILS_REQUEST_DK = 'FETCH_CUTTING_DC_DETAILS_REQUEST_DK';
export const FETCH_CUTTING_DC_DETAILS_SUCCESS_DK = 'FETCH_CUTTING_DC_DETAILS_SUCCESS_DK';
export const FETCH_CUTTING_DC_DETAILS_FAILURE_DK = 'FETCH_CUTTING_DC_DETAILS_FAILURE_DK';

export const FETCH_CUTTING_DC_DETAILS_FORM_REQUEST_DK = 'FETCH_CUTTING_DC_DETAILS_FORM_REQUEST_DK';
export const FETCH_CUTTING_DC_DETAILS_FORM_SUCCESS_DK = 'FETCH_CUTTING_DC_DETAILS_FORM_SUCCESS_DK';
export const FETCH_CUTTING_DC_DETAILS_FORM_FAILURE_DK = 'FETCH_CUTTING_DC_DETAILS_FORM_FAILURE_DK';

// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS
export const FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_REQUEST_DK = 'FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_REQUEST_DK';
export const FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_SUCCESS_DK = 'FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_SUCCESS_DK';
export const FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_FAILURE_DK = 'FETCH_GENERATE_SKU_STYLE_CUTTING_DC_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS
export const FETCH_CUTTING_DC_PROGRAM_REQUEST_DK = 'FETCH_CUTTING_DC_PROGRAM_REQUEST_DK';
export const FETCH_CUTTING_DC_PROGRAM_SUCCESS_DK = 'FETCH_CUTTING_DC_PROGRAM_SUCCESS_DK';
export const FETCH_CUTTING_DC_PROGRAM_FAILURE_DK = 'FETCH_CUTTING_DC_PROGRAM_FAILURE_DK';

// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS
export const FETCH_CUTTING_DC_DETAIL_STYLE_REQUEST_DK = 'FETCH_CUTTING_DC_DETAIL_STYLE_REQUEST_DK';
export const FETCH_CUTTING_DC_DETAIL_STYLE_SUCCESS_DK = 'FETCH_CUTTING_DC_DETAIL_STYLE_SUCCESS_DK';
export const FETCH_CUTTING_DC_DETAIL_STYLE_FAILURE_DK = 'FETCH_CUTTING_DC_DETAIL_STYLE_FAILURE_DK';

export const FETCH_GRN_NO_BY_CUTTING_DC_NO_REQUEST_DK = 'FETCH_GRN_NO_BY_CUTTING_DC_NO_REQUEST_DK';
export const FETCH_GRN_NO_BY_CUTTING_DC_NO_SUCCESS_DK = 'FETCH_GRN_NO_BY_CUTTING_DC_NO_SUCCESS_DK';
export const FETCH_GRN_NO_BY_CUTTING_DC_NO_FAILURE_DK = 'FETCH_GRN_NO_BY_CUTTING_DC_NO_FAILURE_DK';

// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS
export const FETCH_CUTTING_DC_DETAILS_DC_NO_REQUEST_DK = 'FETCH_CUTTING_DC_DETAILS_DC_NO_REQUEST_DK';
export const FETCH_CUTTING_DC_DETAILS_DC_NO_SUCCESS_DK = 'FETCH_CUTTING_DC_DETAILS_DC_NO_SUCCESS_DK';
export const FETCH_CUTTING_DC_DETAILS_DC_NO_FAILURE_DK = 'FETCH_CUTTING_DC_DETAILS_DC_NO_FAILURE_DK';

// FETCH ALL PROPERTIES FROM CUTTING_DC DETAILS BY ID
export const FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST_DK = 'FETCH_CUTTING_DC_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_CUTTING_DC_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE_DK = 'FETCH_CUTTING_DC_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR CUTTING_DC DETAILS
export const CREATE_CUTTING_DC_DETAILS_REQUEST_DK = 'CREATE_CUTTING_DC_DETAILS_REQUEST_DK';
export const CREATE_CUTTING_DC_DETAILS_SUCCESS_DK = 'CREATE_CUTTING_DC_DETAILS_SUCCESS_DK';
export const CREATE_CUTTING_DC_DETAILS_FAILURE_DK = 'CREATE_CUTTING_DC_DETAILS_FAILURE_DK';

// CREATE PROPERTIES FOR CUTTING_DC DETAILS
export const CREATE_CUTTING_DC_DETAILS_GRID_REQUEST_DK = 'CREATE_CUTTING_DC_DETAILS_GRID_REQUEST_DK';
export const CREATE_CUTTING_DC_DETAILS_GRID_SUCCESS_DK = 'CREATE_CUTTING_DC_DETAILS_GRID_SUCCESS_DK';
export const CREATE_CUTTING_DC_DETAILS_GRID_FAILURE_DK = 'CREATE_CUTTING_DC_DETAILS_GRID_FAILURE_DK';

// CREATE PROPERTIES FOR CUTTING_DC DETAILS
export const CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST_DK = 'CREATE_CUTTING_DC_DETAILS_SKU_STYLE_REQUEST_DK';
export const CREATE_CUTTING_DC_DETAILS_SKU_STYLE_SUCCESS_DK = 'CREATE_CUTTING_DC_DETAILS_SKU_STYLE_SUCCESS_DK';
export const CREATE_CUTTING_DC_DETAILS_SKU_STYLE_FAILURE_DK = 'CREATE_CUTTING_DC_DETAILS_SKU_STYLE_FAILURE_DK';

export const CREATE_STICHING_DC_DETAILS_SKU_STYLE_REQUEST_DK = 'CREATE_STICHING_DC_DETAILS_SKU_STYLE_REQUEST_DK';
export const CREATE_STICHING_DC_DETAILS_SKU_STYLE_SUCCESS_DK = 'CREATE_STICHING_DC_DETAILS_SKU_STYLE_SUCCESS_DK';
export const CREATE_STICHING_DC_DETAILS_SKU_STYLE_FAILURE_DK = 'CREATE_STICHING_DC_DETAILS_SKU_STYLE_FAILURE_DK';

export const CREATE_PRINTING_DC_DETAILS_SKU_STYLE_REQUEST_DK = 'CREATE_PRINTING_DC_DETAILS_SKU_STYLE_REQUEST_DK';
export const CREATE_PRINTING_DC_DETAILS_SKU_STYLE_SUCCESS_DK = 'CREATE_PRINTING_DC_DETAILS_SKU_STYLE_SUCCESS_DK';
export const CREATE_PRINTING_DC_DETAILS_SKU_STYLE_FAILURE_DK = 'CREATE_PRINTING_DC_DETAILS_SKU_STYLE_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_CUTTING_DC_DETAILS_DK = 'CREATE_USER_FORM_CUTTING_DC_DETAILS_DK';
export const RESET_CUTTING_DC_DETAIL_GENERATE_SKU_DK = 'RESET_CUTTING_DC_DETAIL_GENERATE_SKU_DK';

export const CREATE_STICHING_DETAIL_FORM = 'CREATE_STICHING_DETAIL_FORM';

export const CREATE_PRINTING_DETAIL_FORM = 'CREATE_PRINTING_DETAIL_FORM';

// UPDATE PROPERTIES FOR CUTTING_DC DETAILS
export const UPDATE_CUTTING_DC_DETAILS_REQUEST_DK = 'UPDATE_CUTTING_DC_DETAILS_REQUEST_DK';
export const UPDATE_CUTTING_DC_DETAILS_SUCCESS_DK = 'UPDATE_CUTTING_DC_DETAILS_SUCCESS_DK';
export const UPDATE_CUTTING_DC_DETAILS_FAILURE_DK = 'UPDATE_CUTTING_DC_DETAILS_FAILURE_DK';

// FETCH SINGLE CUTTING_DC_DETAILS
export const FETCH_SINGLE_CUTTING_DC_DETAILS_REQUEST_DK = 'FETCH_SINGLE_CUTTING_DC_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_CUTTING_DC_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_CUTTING_DC_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_CUTTING_DC_DETAILS_FAILURE_DK = 'FETCH_SINGLE_CUTTING_DC_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR CUTTING_DC DETAILS
export const DELETE_CUTTING_DC_DETAILS_REQUEST_DK = 'DELETE_CUTTING_DC_DETAILS_REQUEST_DK';
export const DELETE_CUTTING_DC_DETAILS_SUCCESS_DK = 'DELETE_CUTTING_DC_DETAILS_SUCCESS_DK';
export const DELETE_CUTTING_DC_DETAILS_FAILURE_DK = 'DELETE_CUTTING_DC_DETAILS_FAILURE_DK';

export const FETCH_CUTTING_DC_PREVIOUS_LIST_REQUEST_DK = 'FETCH_CUTTING_DC_PREVIOUS_LIST_REQUEST_DK';
export const FETCH_CUTTING_DC_PREVIOUS_LIST_SUCCESS_DK = 'FETCH_CUTTING_DC_PREVIOUS_LIST_SUCCESS_DK';
export const FETCH_CUTTING_DC_PREVIOUS_LIST_FAILURE_DK = 'FETCH_CUTTING_DC_PREVIOUS_LIST_FAILURE_DK';

// USERFORM RESET

export const CUTTING_DC_DETAILS_USERFORM_RESET_DK = 'CUTTING_DC_DETAILS_USERFORM_RESET_DK';

export const CUTTING_DC_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET_DK = 'CUTTING_DC_DETAILS_GENERATE_GRID_OUTPUT_DATA_SET_DK';

export const CUTTING_DC_DETAILS_GENERATE_GRID_FINAL_DATA_SET_DK = 'CUTTING_DC_DETAILS_GENERATE_GRID_FINAL_DATA_SET_DK';

export const CUTTING_DC_DETAILS_EDIT_FABRIC_DK_REQUEST = 'CUTTING_DC_DETAILS_EDIT_FABRIC_DK_REQUEST';

export const CUTTING_DC_DETAILS_EDIT_FABRIC_DK_SUCCESS = 'CUTTING_DC_DETAILS_EDIT_FABRIC_DK_SUCCESS';

export const CUTTING_DC_DETAILS_EDIT_FABRIC_DK_FAILURE = 'CUTTING_DC_DETAILS_EDIT_FABRIC_DK_FAILURE';

export const CUTTING_DC_DETAILS_DELETE_FABRIC_DK_REQUEST = 'CUTTING_DC_DETAILS_DELETE_FABRIC_DK_REQUEST';

export const CUTTING_DC_DETAILS_DELETE_FABRIC_DK_SUCCESS = 'CUTTING_DC_DETAILS_DELETE_FABRIC_DK_SUCCESS';

export const CUTTING_DC_DETAILS_DELETE_FABRIC_DK_FAILURE = 'CUTTING_DC_DETAILS_DELETE_FABRIC_DK_FAILURE';

export const RESET_FABRIC_EDIT_FORM = 'RESET_FABRIC_EDIT_FORM';

export const CUTTING_DC_DETAILS_DELETE_DK_REQUEST = 'CUTTING_DC_DETAILS_DELETE_DK_REQUEST';

export const CUTTING_DC_DETAILS_DELETE_DK_SUCCESS = 'CUTTING_DC_DETAILS_DELETE_DK_SUCCESS';

export const CUTTING_DC_DETAILS_DELETE_DK_FAILURE = 'CUTTING_DC_DETAILS_DELETE_DK_FAILURE';


export const CUTTING_CLOSE_BTN_POST_REQUEST = 'CUTTING_CLOSE_BTN_POST_REQUEST'
export const CUTTING_CLOSE_BTN_POST_SUCCESS = 'CUTTING_CLOSE_BTN_POST_SUCCESS'
export const CUTTING_CLOSE_BTN_POST_FALIURE = 'CUTTING_CLOSE_BTN_POST_FALIURE'



export const CUTTING_CHECK_ALL_UPDATE_REQUEST = 'CUTTING_CHECK_ALL_UPDATE_REQUEST'
export const CUTTING_CHECK_ALL_UPDATE_SUCCESS = 'CUTTING_CHECK_ALL_UPDATE_SUCCESS'
export const CUTTING_CHECK_ALL_UPDATE_FALIURE = 'CUTTING_CHECK_ALL_UPDATE_FALIURE'


export const RESET_CUTTING_ID = 'RESET_CUTTING_ID'